<template>
  <div v-bind:class="fav">
    <div class="w-100">
      <div class="description">{{ row.description }}<br /></div>
    </div>
    <div class="d-flex justify-content-between">
      <div class="clickarea w-100" v-on:dblclick="doFavourite">
        <span class="info">{{ row.manufacturer }} {{ row.ean }} </span><br />
        <span class="h3">{{ row.sales_price }}kr / {{ row.unit }}<br /></span>
        <span class="info mt-0 pt-0">{{ sales_price_per_unit }}kr/st</span>
      </div>

      <div class="d-flex flex-column mt-auto ms-auto">
        <div class="pb-1 text-center h4 row_total">{{ total_sum }}&nbsp;kr</div>
        <div class="mt-auto input-group input-group-sm">
          <div v-on:click="row.ordered_quantity--" class="input-group-prepend">
            <span class="input-group-text dexx" id="">-</span>
          </div>
          <input
            type="number"
            min="0"
            class="form-control text-center quantity"
            v-on:keyup.enter="validateQuantity"
            v-model="input_ordered_quantity"
            pattern="[0-9]*"
            @focusout="validateQuantity"
            placeholder="0"
          />
          <div v-on:click="row.ordered_quantity++" class="input-group-append">
            <span class="input-group-text incx">+</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";

//axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

Vue.filter("number_format", function(
  number,
  decimals,
  dec_point,
  thousands_sep
) {
  number = number * 1; //makes sure `number` is numeric value
  var str = number
    .toFixed(decimals ? decimals : 0)
    .toString()
    .split(".");
  var parts = [];
  for (var i = str[0].length; i > 0; i -= 3) {
    parts.unshift(str[0].substring(Math.max(0, i - 3), i));
  }
  str[0] = parts.join(thousands_sep ? thousands_sep : ",");
  return str.join(dec_point ? dec_point : ".");
});

export default {
  props: ["row", "visible"],
  name: "Orderrow",
  components: {},
  data() {
    return {
      input_ordered_quantity: ""
    };
  },
  watch: {
    ordered_quantity: function(val) {
      if (val < 0) {
        this.row.ordered_quantity = 0;
        return;
      }
      this.input_ordered_quantity = this.row.ordered_quantity;

      var data = new Object();
      data.amount = this.row.ordered_quantity;
      data.article_id = this.row.article_id;


      //axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

      axios
        .post(
          "http://localhost:8080/api/1/orderrow",
          {
            amount: this.row.ordered_quantity,
            article_id: this.row.article_id,
            token: this.session_token()
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: 98239842543
            }
          }
        )
        .then(response => {
          console.log(response);
          if (response.status === 201) {
            console.log(response.data.data);
          }
        })
        .catch(err => console.log(err));
    }
  },
  computed: {
    fav() {
      return this.row.is_fav !== null ? "fav" : "bg-white";
    },
    total_sum: function() {
      return this.$options.filters.number_format(
        this.row.sales_price * this.row.ordered_quantity,
        2,
        ".",
        ","
      );
    },
    sales_price_per_unit: function() {
      return this.$options.filters.number_format(
        parseFloat(this.row.ean) / this.row.sales_price,
        2,
        ".",
        ","
      );
    },
    ordered_quantity() {
      return this.row.ordered_quantity;
    }
  },
  methods: {
    session_token: function() {
      return JSON.parse(sessionStorage.getItem("session")).token;
    },

    validateQuantity: function(e) {
      if (this.row.ordered_quantity !== this.input_ordered_quantity) {
        this.row.ordered_quantity = this.input_ordered_quantity;
      }
    },
    doFavourite: function(e) {
      headers = {
        Authorization: this.sales_price_per_unit(),
        "Content-Type": "application/json"
      };

      if (this.row.is_fav) {
        var request = axios.delete(
          "https://eavedev.eu.ngrok.io/api/1/favourite/" + this.row.is_fav,
          {
            headers: headers
          }
        );
      }

      if (!this.row.is_fav) {
        var request = axios.post(
          "https://eavedev.eu.ngrok.io/api/1/favourite/" + this.row.article_id,
          {},
          {
            headers: headers
          }
        );
      }

      if (request) {
        request.then(response => {
          if (response.status == 202) {
            if (response.data.action == "delete") {
              this.row.is_fav = null;
            }

            if (response.data.action == "add") {
              this.row.is_fav = this.row.article_id;
            }
          }
        });
      }
    }
  },
  mounted() {
    this.input_ordered_quantity = this.row.ordered_quantity;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Orderrow.vue